import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

const formatText = (text) => {
  let newText = text.split("-");
  newText = newText.join(" ");

  return newText;
};

const mapCategories = (arr) => {
  return arr.map((item, index) => {
    return (
      <Link to={`/blog/categories/${item}/1`} key={index}>
        {` ${formatText(item)}${index !== arr.length - 1 ? "," : ""}`}
      </Link>
    );
  });
};

export const mapBlogs = (current, blogs, isPage = false) => {
  const start = current * 5 - 5;
  const end = current * 5;

  let toMap = blogs.slice(start, end);

  return toMap.map((blog, index) => {
    return (
      <div className="row" key={index}>
        <div className="col-12 blog-item" >
          <Link to={blog.destination}>
            <div
              className="image transition-3"
              style={{ backgroundImage: `url(${blog.image})` }}
            ></div>
          </Link>
          {!isPage ? (
            <h3>{blog.title}</h3>
          ) : (
            <h1 className="my-2">{blog.title}</h1>
          )}
          <p>
            {blog.date} / in {mapCategories(blog.categories)} {blog.author ? `/ ${blog.author}` : ""}
          </p>
          {!isPage ? (
            <Link to={blog.destination}>
              Read more <FontAwesomeIcon icon={faChevronRight} />
            </Link>
          ) : null}
        </div>
      </div>
    );
  });
};
